// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"styles_imageWrapper__AjM9Y","imageWrapperHasCaption":"styles_imageWrapperHasCaption__KeUgy","caption":"styles_caption__KNIEO"};